import { useStoreon } from "storeon/react";
import { INavigationEvents, INavigationStore } from "../store/navigationStore";

export const useNavigationStore = () => {
  const { navigationStore, dispatch: navigationDispatch } =
    useStoreon<INavigationStore, INavigationEvents>("navigationStore");

  return { navigationStore, navigationDispatch };
};